<app-share-button ></app-share-button>
<div class="row">
    <div class="col-md-8  ScrollStyle-1">
        <div class="card crd p-3">
            <div class="row">
                <div class="col-md-10 col10 mt-2" (mouseover)="showpayment(true,'2')"
                    (mouseout)="showpayment(false,'2')" id="2">
                    <h2 >पे बटन </h2>
                </div>
                <div class="col-md-2 col2 "><a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
                    alt=""> </button> </a></div>

                    <div class="col-md-12" (mouseover)="showpayment(true,'1')" (mouseout)="showpayment(false,'1')" id="5">
                        <div style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">
    
                            <iframe class="i-frame" src="https://www.youtube.com/embed/bL69f97X_e8?si=RpuULWFNv751Rhi9"
                                title="YouTube video player" frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                allowfullscreen></iframe>
                        </div>
                    </div>
               
                <div class="col-md-12">

                    <label for="" class="mt-2" >पे बटन एक मौलिक है
                        द्वारा प्रदान की गई सुविधा
                        पे जी
                        वह
                        व्यवसायों को सुरक्षित और सुविधाजनक तरीके से ऑनलाइन भुगतान स्वीकार करने की अनुमति देता है। यह
                        सरल
                        व्यापारियों और ग्राहकों दोनों के लिए त्वरित भुगतान प्रक्रिया प्रदान करके
                        और
                        लेन-देन शुरू करने का सीधा तरीका. भुगतान बटन संभवतः संदर्भित करता है
                        एक को
                        पे जी की भुगतान प्रसंस्करण सेवा द्वारा प्रदान किया गया विशिष्ट बटन या तत्व।
                        यह
                        ग्राहकों को सक्षम बनाने के लिए बटन को आपकी वेबसाइट या ऐप में एकीकृत किया जा सकता है
                        आरंभ करना
                        भुगतान सुरक्षित रूप से</label>
                    <label for="" class="mt-3" >जब कोई ग्राहक "भुगतान करें" पर क्लिक करता है
                        बटन," यह
                        आम तौर पर
                        भुगतान प्रक्रिया को ट्रिगर करता है, जिससे ग्राहक को अपना भुगतान दर्ज करने की अनुमति मिलती है
                        विवरण
                        और लेनदेन पूरा करें. पे जी व्यापारियों को आवश्यक चीज़ें प्रदान करता है
                        औजार
                        और
                        ऑनलाइन भुगतान की सुविधा के लिए "पे बटन" सहित बुनियादी ढाँचा
                        और
                        सुनिश्चित करना
                        लेन-देन की सुरक्षा और दक्षता. </label>
                   
                </div>
                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'1')"
                (mouseout)="showpayment(false,'1')" id="101"> <h2> कार्यप्रवाह
                </h2>
               
                <div class="col-md-12 mt-3">
                    <img src="./assets/GIF/Creating Pay Button.gif" width="95%" height="95%"
                 alt="" style="border-radius: 10px;">
                 </div>
                </div>

                <div class="col-md-12 mt-4" (mouseover)="showpayment(true,'3')"
                    (mouseout)="showpayment(false,'3')" id="3">

                 
                    <h2 >हमारे वेतन बटन के मुख्य लाभ: </h2>

                    <ol >
                        <li class="mt-3"><b>तेज़ और सहज भुगतान:</b> हमारे पे बटन के साथ, आपके ग्राहक
                            कुछ ही क्लिक में अपना भुगतान पूरा कर सकते हैं, चेकआउट के समय को कम कर
                            सकते हैं और अपने समग्र खरीदारी अनुभव को बढ़ा सकते हैं। </li>

                        <li class="mt-3">

                            <b>सुरक्षित लेनदेन:</b> आपकी सुरक्षा हमारी सर्वोच्च प्राथमिकता है। पे
                            बटन यह सुनिश्चित करता है कि सभी लेनदेन उच्चतम स्तर के एन्क्रिप्शन और
                            सुरक्षा उपायों द्वारा सुरक्षित हैं।
                        </li>

                        <li class="mt-3">

                            <b>मोबाइल रिस्पॉन्सिव:</b> हमारा पे बटन सभी डिवाइसों पर त्रुटिहीन ढंग से
                            काम करने के लिए डिज़ाइन किया गया है, जिससे भुगतान का सहज अनुभव सुनिश्चित
                            होता है।
                        </li>

                        <li class="mt-3">

                            <b>एकाधिक भुगतान विकल्प:</b> क्रेडिट/डेबिट कार्ड, नेट बैंकिंग, यूपीआई,
                            मोबाइल वॉलेट और अन्य सहित भुगतान विधियों की एक विस्तृत श्रृंखला में से
                            चुनें।
                        </li>

                        <li class="mt-3">

                            <b>एक-क्लिक भुगतान:</b> लौटने वाले ग्राहकों के लिए, हमारा पे बटन एक
                            सुविधाजनक एक-क्लिक भुगतान विकल्प प्रदान करता है, जिससे बाद के लेनदेन के
                            दौरान आपका समय और प्रयास बचता है।


                        </li>

                        <li class="mt-3">
                            <b>आसान रिफंड और विवाद:</b>रिफंड या विवाद की अप्रत्याशित स्थिति में,
                            हमारा पे बटन परेशानी मुक्त समाधान सुनिश्चित करते हुए प्रक्रिया को
                            सुव्यवस्थित करता है।
                        </li>


                    </ol>
                </div>

                <div class="col-md-12 mt-4" (mouseover)="showpayment(true,'4')"
                    (mouseout)="showpayment(false,'4')" id="4">
                  
                    <h2 >
                        इस प्रकार आप पे जी में अपना स्वयं का अनुकूलित पे बटन बना सकते हैं:
                    </h2>
                    <ul>
                      
                        <li class="mt-3" ><b>अपने खाते में साइन इन करें: </b>&nbsp;यदि
                            आपने पहले से नहीं किया है, तो पे जी के साथ एक खाते के लिए साइन अप करें।
                            यह त्वरित और आसान है! </li>

                        <li class="mt-3" ><b>अपने डैशबोर्ड तक पहुंचें: </b>&nbsp;एक बार
                            लॉग इन करने के बाद, अपने खाते के डैशबोर्ड पर जाएं, जहां आपको एक "Create
                            button" मिलेगा, उस बटन पर क्लिक करने पर आपको " Pay Button " अनुभाग
                            मिलेगा। </li>

                        <div class="row">
                            <div class="col-md-12 mt-3">
                                <img src="./assets/button1.png" width="100%" height="100%" alt="">
                            </div>
                        </div>

                       
                        <li class="mt-3" >


                            आप "Pay Now", "Buy Now", "Donate", और "Add to cart" दिए गए चार भुगतान
                            बटनों में से किसी एक का चयन कर सकते हैं।
                        </li>
                        <div class="row">
                            <div class="col-md-12 mt-3 text-center">
                                <img src="./assets/button2.png" width="100%" height="100%" alt="">
                            </div>
                        </div>

                        
                        <li class="mt-3" >
                            आप अपने पे बटन को संशोधित कर सकते हैं और पे बटन चुनने के बाद उपलब्ध
                            थीमों में से किसी एक को चुनकर बटन का पूर्वावलोकन प्राप्त कर सकते हैं।
                        </li>
                        <div class="row">
                            <div class="col-md-12 mt-3 text-center">
                                <img src="./assets/button3.png" width="100%" height="100%" alt="">
                            </div>
                        </div>


                       
                        <li class="mt-3" >
                            बटन बनाने के बाद, "Assignment" पर क्लिक करें। यहां से आप कोड को कॉपी कर
                            सकते हैं और इसे HTML प्रारूप में पेस्ट कर सकते हैं और फिर इसे अपने
                            आधिकारिक वेबपेज पर जहां चाहें वहां एम्बेड कर सकते हैं।
                        </li>
                        <div class="row">
                            <div class="col-md-12 mt-3 text-center">
                                <img src="./assets/button 4.png" width="100%" height="100%" alt="">
                            </div>

                            <div class="col-md-12 mt-3 text-center">
                                <img src="./assets/button 5.png" width="100%" height="100%" alt="">
                            </div>
                        </div>

                       
                        <li >
                            व्यापारी ग्राहकों द्वारा किए गए सभी चार बटन के लेनदेन इतिहास की जांच कर
                            सकते हैं।
                        </li>
                    </ul>
                </div>
                <div class="col-md-12">
                  
                    <h2 class="mt-4" (mouseover)="showpayment(true,'5')"
                        (mouseout)="showpayment(false,'5')" id="5" >
                        बटनों का निम्नलिखित विवरण आपको सही प्रकार चुनने में सहायता कर सकता है:
                    </h2>
                   
                    

                 

                    <label class="mt-3" ><b>" Buy Now " बटन: </b>&nbsp; "Buy Now" बटन
                        का उपयोग एकल-आइटम खरीदारी के लिए किया जा सकता है। जब कोई ग्राहक इस बटन पर
                        क्लिक करता है, तो उन्हें सीधे चेकआउट पृष्ठ पर ले जाया जाता है, जहां वे
                        विशिष्ट उत्पाद या सेवा के लिए खरीदारी पूरी कर सकते हैं। उन्होंने चयन कर लिया
                        है। यह बटन उन स्थितियों के लिए आदर्श है जहां ग्राहक पहले ही अपना मन बना चुका
                        है और त्वरित और सुव्यवस्थित खरीदारी प्रक्रिया चाहता है।

                    </label>
                    <label class="mt-3" ><b> "Pay Now" बटन:</b>&nbsp;" Pay Now " बटन का
                        उपयोग उन स्थितियों के लिए किया जा सकता है जहां ग्राहक ने पहले ही अपने शॉपिंग
                        कार्ट में आइटम जोड़ दिए हैं और पारंपरिक चेकआउट प्रक्रिया से गुजरे बिना सीधे
                        भुगतान के लिए आगे बढ़ना चाहता है। यह आमतौर पर एक-क्लिक भुगतान विकल्पों या
                        भुगतान अनुरोध पृष्ठों पर देखा जाता है जहां कुल राशि प्रदर्शित होती है, और
                        ग्राहक " Pay Now " बटन पर क्लिक करके भुगतान पूरा कर सकता है।

                    </label>

                    <label class="mt-3" ><b> " Donate " बटन: </b>&nbsp;" Donate " बटन
                        का उपयोग उन वेबसाइटों या प्लेटफार्मों पर किया जा सकता है जहां संगठन या
                        व्यक्ति धर्मार्थ कारणों, गैर-लाभकारी गतिविधियों या धन उगाहने के उद्देश्यों
                        के लिए दान मांगते हैं। जब उपयोगकर्ता "दान करें" बटन पर क्लिक करते हैं, तो
                        उन्हें आमतौर पर एक भुगतान पृष्ठ पर निर्देशित किया जाता है जहां वे दान राशि
                        चुन सकते हैं और लेनदेन पूरा कर सकते हैं।

                    </label>

                    <label class="mt-3" ><b> " Add to Cart " बटन: </b>&nbsp; " Add to
                        Cart " बटन का उपयोग ई-कॉमर्स वेबसाइटें अपने ग्राहकों को उन वस्तुओं को जोड़ने
                        की अनुमति देने के लिए कर सकती हैं जिन्हें वे अपने वर्चुअल शॉपिंग कार्ट में
                        खरीदना चाहते हैं। यह ग्राहकों को अपनी खरीदारी को अंतिम रूप देने के लिए
                        चेकआउट पृष्ठ पर आगे बढ़ने से पहले खरीदारी जारी रखने और अधिक आइटम जोड़ने में
                        सक्षम बनाता है।



                    </label>
                </div>
            </div>
        </div>
   </div>
    <div class="col-md-4 hide-tbl">
        <div class="card crd p-4">
            <div class="row">
                <div class="col-md-12">
                   
                    <h5 >
                        विषयसूची :
                    </h5>
                </div>

                <div class="col-md-12 mt-3">
                    <a href="#2">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                                    alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                
                                <span style="cursor: pointer;" class="textHover"
                                    [ngClass]="{'text':colors=='2'}" (click)="color('2')"
                                    >पे बटन का परिचय </span>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-3">
                    <a href="#101">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/GIF/GIF.svg" class="tab-icon intro"
                                    alt="">
                                </div>
                            <div class="col-md-10 mt-1" >
                               
                                <span style="cursor: pointer;" class="textHover"
                                    [ngClass]="{'text':colors=='1'}" (click)="color('1')"
                                    >
                                    कार्यप्रवाह</span>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-3">
                    <a href="#3">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                                    alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                
                                <span style="cursor: pointer;" class="textHover"
                                    [ngClass]="{'text':colors=='3'}" (click)="color('3')"
                                    >
                                    पे बटन के लाभ </span>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-3">
                    <a href="#4">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                                    alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                               
                                <span style="cursor: pointer;" class="textHover"
                                    [ngClass]="{'text':colors=='4'}" (click)="color('4')"
                                    >
                                    वेतन बटन बनाना </span>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-3">
                    <a href="#5">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                                    alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                               
                                <span style="cursor: pointer;" class="textHover"
                                    [ngClass]="{'text':colors=='5'}" (click)="color('5')"
                                    >पे बटन के प्रकार </span>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-9 hide ft-9">
        <hr>
        <div class=" row crd">
            <div class="col-md-8">
                
                <a [routerLink]="['/g-store']"> <button class="btn btn-color" (click)="menues('G-Store')" > <img
                        src="./assets/Arrow 3.svg" alt="">&nbsp;&nbsp;जी-स्टोर

                </button></a>
            </div>
            <div class="col-md-4    ">
               
                <a [routerLink]="['/payment-qr']"> <button class="btn btn-color" (click)="menues('Payment QR')" >पेमेंट
                    क्यूआर
                    &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>
            </div>
        </div>
    </div>
    </div>